import { render, staticRenderFns } from "./LessonStep.vue?vue&type=template&id=47c6000a&scoped=true&"
import script from "./LessonStep.vue?vue&type=script&lang=js&"
export * from "./LessonStep.vue?vue&type=script&lang=js&"
import style0 from "./LessonStep.vue?vue&type=style&index=0&id=47c6000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6000a",
  null
  
)

export default component.exports